<template>
  <div id="creditRules">
    <span style="font-weight: bold;margin-right: 20px">前台规则提示</span><el-button size="mini" @click.native="updateCreditExplain">修改</el-button>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="workWayName" label="生效途径"></el-table-column>
      <el-table-column prop="type" label="类型"></el-table-column>
      <el-table-column prop="ruleExplain" label="规则说明"></el-table-column>
      <el-table-column prop="creditNum" label="积分额度"></el-table-column>
      <el-table-column prop="isWork" label="生效">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="isWorkChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editRule(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      title="积分额度设置"
      :visible.sync="dialogVisible"
      @close="closeCreditsDialog"
      width="30%">
      <el-input v-model="creditsValue" type="number" placeholder="请输入积分额"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCreditsDialog">取 消</el-button>
        <el-button type="primary" @click="changeCreditsSure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="前台积分规则提示"
      :visible.sync="dialogExplainVisible"
      width="50%"
      :before-close="handleExplainClose">
      <el-input
        type="textarea"
        :rows="10"
        :placeholder="'请输入前台积分规则提示内容'"
        v-model="creditExplain">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleExplainClose">取 消</el-button>
        <el-button type="primary" @click="submitCreditExplain">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "credit-rules",
    data(){
        return{
          tableData:[],
          pageInfo:{
            currentPage:1,
            pageSize:20,
            total:0
          },
          dialogVisible:false,
          creditsValue:null,
          ruleId:null,
          creditExplain:"",
          dialogExplainVisible:false,
        }
    },
    created(){
      this.getCreditExplain()
      this.getData()
    },
    methods:{
      getCreditExplain(){
        utils.axiosMethods({
          method:"GET",
          url:"/api/creditManage/queryCreditExplain",
          callback:(res =>{
            this.creditExplain = res.data.obj.content;
          })
        })
      },
      //获取数据
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.tableData = response.data.list
            this.pageInfo.total = response.data.total;
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/queryRules",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{

          },
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      //修改是否生效
      isWorkChange(row){
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/changeRulesWork",
          params:{
            id:row.id,
            isWork:row.isWork == '1' ? '0' :'1'
          },
          callback:(res => {
            this.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            this.getData();
          })
        })
      },
      //编辑规则
      editRule(row){
        this.dialogVisible = true;
        this.ruleId = row.id;
        this.creditsValue = row.creditNum;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      //关闭积分额度设置
      closeCreditsDialog(){
        this.dialogVisible = false;
        this.ruleId = null;
        this.creditsValue = null;
      },
      //  确认修改积分额度
      changeCreditsSure(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/changeCreditNum",
          params:{
            id:this.ruleId,
            creditNum:this.creditsValue
          },
          callback:(res => {
            this.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            this.closeCreditsDialog();
            this.getData();
          })
        })
      },
      updateCreditExplain(){
        this.dialogExplainVisible = true;
      },
      handleExplainClose(){
        this.dialogExplainVisible = false;
      },
      submitCreditExplain(){
        let formDate = new FormData();
        formDate.append("content",this.creditExplain);
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/updateCreditExplain",
          data:formDate,
          callback:(res =>{
            this.handleExplainClose();
          })
        })
      },
      workWayFormatter(row, column, cellValue, index){
        if(cellValue == "1"){
          return "出售商品"
        }else if(cellValue == "2"){
          return "用户第一次注册"
        }else if(cellValue == "3"){
          return "成功评价"
        }else if(cellValue == "4"){
          return "有奖反馈"
        }
      }
    }
  }
</script>

<style scoped lang="less">
  #creditRules{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/creditRules.vue